<span class="self-care-chip">
    <span class="self-care-chip__label">{{('shared.self-care-chip.self-care' | exp:'':'Autocuidado') }}</span>
</span>
